import { HttpEvent, HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, from, of, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';

export const authTokenInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const excludedUrls = [ '/auth/'];
  const authService = inject(AuthService); 
  const accessToken = authService.getAccessToken();
    if (excludedUrls.some(excludedPath => req.url.includes(excludedPath))) {
    return next(req);
  }

  let clonedRequest = req;
  if (accessToken) {
    clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  return next(clonedRequest).pipe(
    catchError((error) => {
      if (error.status === 401) {
        return authService.refreshToken().pipe(
          switchMap(() => {
            const newAccessToken =authService.getAccessToken();
            clonedRequest = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newAccessToken}`,
              },
            });
            return next(clonedRequest);
          }),
           catchError((refreshError) => {
            // If token refresh fails, force logout
            console.error('Token refresh failed:', refreshError);
            authService.forceLogout('Token refresh failed');
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    })
  );
};
